import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    this.#sortEventPosts();
    super.connectedCallback();
    this.setAttribute('initialized', '');
  }

  /**
   * Orders event posts by their Date metafield before the paginated list initializes.
   * Posts without a sort date retain their relative order and appear after dated events.
   */
  #sortEventPosts() {
    const grid = this.querySelector('[data-sort-by-event-date="true"]');
    if (!grid) return;

    const posts = Array.from(grid.querySelectorAll(':scope > [data-event-sort-key]'));
    posts.sort((firstPost, secondPost) => {
      const firstDate = Number(firstPost.getAttribute('data-event-sort-key'));
      const secondDate = Number(secondPost.getAttribute('data-event-sort-key'));

      return firstDate - secondDate;
    });

    grid.append(...posts);
  }

  get shouldPushPageUrl() {
    return false;
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
